import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import { makeSelectIsDownloading } from "./selectors"
import { getTemplate } from "./actions"
import reducer from "./reducer"
import saga from "./saga"
import { Link } from "react-router-dom"
import backIcon from "images/left-arrow.svg"
import checkIcon from "images/check-measure.svg"
import {
  Button,
  Table,
  Spin,
  Input,
  Tooltip,
  Popover,
  Switch,
  Select,
  Empty,
} from "antd"
import ModalInvitate from "./Components/ModalInvitate"
import ModalEmail from "./Components/ModalEmail"
import ModalDesactivate from "./Components/ModalDesactivate"
import { requestUpgradeApi } from "services/requestUpgrade"
import imageEmptyFreemium from "images/empty/empty-balloon.svg"
import { filter } from "lodash"
import "./index.less"
import {
  CloseCircleOutlined,
  SearchOutlined,
  UploadOutlined,
  DownloadOutlined,
} from "@ant-design/icons"
import { buttonAction_btns } from "../../../../components/Snowplow/config2"

const { Option } = Select

const Leader = (props) => {
  const [modalInvite, setModalInvite] = useState(false)
  const [modalEmail, setModalEmail] = useState(false)
  const [modalDesactivate, setModalDesactivate] = useState(false)
  const [listLeaders, setListLeaders] = useState([])
  const [textFilter, setTextFilter] = useState("")
  const [selectFilter, setSelectFilter] = useState([])
  const [usersSelected, setUsersSelected] = useState([])
  const [usersSelectedTable, setUsersSelectedTable] = useState([])
  const [loading, setLoading] = useState(false)
  const [isFilter, setIsFilter] = useState(false)
  const [countEmployees, setCountEmployees] = useState(0)
  const [countLeaders, setCountLeaders] = useState(0)
  const usersSelectedActive = usersSelectedTable.filter(
    (e) => parseInt(e.user_active) === 1
  )
  const usersSelectedInactive = usersSelectedTable.filter(
    (e) => parseInt(e.user_active) === 0
  )
  const usersSelectedDisable = usersSelectedTable.filter(
    (e) => parseInt(e.user_active) === 0
  )
  const usersSelectedToInvite = usersSelectedTable.filter(
    (e) => parseInt(e.user_active) === 1
  )
  const showData = countLeaders > 0
  const columns = [
    {
      title: "Nombre",
      dataIndex: "first_name",
      sorter: (a, b) => {
        return a.first_name.localeCompare(b.first_name)
      },
      width: "20%",
    },
    {
      title: "Apellidos",
      dataIndex: "last_name",
      sorter: (a, b) => {
        return a.last_name.localeCompare(b.last_name)
      },
      width: "20%",
      render: (last_name, record) => (
        <span>
          {record.last_name} {record.second_last_name}
        </span>
      ),
    },
    {
      title: "Correo electrónico",
      dataIndex: "email",
      width: "20%",
    },
    {
      title: "Correo de invitación",
      dataIndex: "user_invited",
      // sorter: (a, b) => a.user_invited - b.user_invited,
      className: "leadersOptionSend",
      render: (user_invited, row) => {
        const send = (
          <Popover
            placement="top"
            {...(row.user_active ? { visible: false } : {})}
            content={
              <div style={{ maxWidth: 275 }}>
                No es posible enviar un correo a un <br /> usuario que se
                encuentra <b>desactivado</b>.
              </div>
            }>
            <span
              style={
                !row.user_active
                  ? { cursor: "not-allowed", color: "#BFBFBF" }
                  : { cursor: "pointer", color: "#1890ff" }
              }
              onClick={() => {
                if (!row.user_active) return false
                setUsersSelected([{ ...row }])
                setModalEmail(true)
                buttonAction_btns("Reenviar correo a lider")
              }}>
              {user_invited ? "Reenviar" : "Enviar"}
            </span>
          </Popover>
        )
        return !user_invited ? (
          send
        ) : (
          <>
            <img
              className="leadersOptionSend-image"
              style={{ width: 12, height: 11 }}
              src={checkIcon}
            />
            <div className="leadersOptionSend-action">{send}</div>
          </>
        )
      },
    },
    {
      title: "Usuario Líder",
      dataIndex: "user_active",
      render: (user_active, row) => {
        return (
          <div>
            <Switch
              onClick={() => {
                if (user_active) {
                  setModalDesactivate(true)
                } else {
                  setModalInvite(true)
                }
                setUsersSelected([{ ...row }])
              }}
              checked={!!user_active}
            />
          </div>
        )
      },
    },
  ]

  const getLeaders = async () => {
    setLoading(true)
    let result = await fetchGlobalApi({
      method: "GET",
      endpoint: "employees/teamleader/",
    })
    const listLeader = result.data.data.result.leaders
    setListLeaders(listLeader)
    setCountEmployees(result.data.data.result.count_employees)
    setCountLeaders(result.data.data.result.count_leaders)
    setLoading(false)

    let idSelectedUsers = usersSelectedTable.flatMap((e) => e.id_employee)
    setUsersSelectedTable(
      listLeader.filter((e) => idSelectedUsers.includes(e.id_employee))
    )
  }

  useEffect(() => {
    getLeaders()
  }, [])

  const renderEmpty = () => {
    if (countEmployees === 0 && !loading) {
      return (
        <div style={{ padding: "1rem", textAlign: "center", color: "#555155" }}>
          <p>
            No es posible asignar líderes sin haber primero asignado{" "}
            <b>líderes</b> en el organigrama.
          </p>
          <Button style={{ color: "#2694FC", marginTop: "0.5rem" }}>
            <Link to="organization#collaborators">
              <img alt="back-icon" src={backIcon} style={{ marginRight: 10 }} />
              Ir a Colaboradores
            </Link>
          </Button>
        </div>
      )
    }
    if (countLeaders === 0 && !loading && !isFilter) {
      return (
        <div style={{ padding: "1rem", textAlign: "center", color: "#555155" }}>
          <p>No hay líderes asignados para mostrar.</p>
          <Button style={{ color: "#2694FC", marginTop: "0.5rem" }}>
            <Link to="organization#collaborators">
              <img alt="back-icon" src={backIcon} style={{ marginRight: 10 }} />
              Ir a Colaboradores
            </Link>
          </Button>
        </div>
      )
    }
  }

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setUsersSelectedTable(selectedRows)
    },
    getCheckboxProps: (record) => ({
      name: record.name,
    }),
  }

  const getDataTable = () => {
    if (textFilter || selectFilter) {
      const filters = filter(listLeaders, (item) => {
        return (
          item.first_name
            .toLowerCase()
            .includes(textFilter.toLocaleLowerCase()) ||
          item.last_name.toLowerCase().includes(textFilter.toLowerCase()) ||
          `${item.last_name} ${item.second_last_name}`
            .toLowerCase()
            .includes(textFilter.toLowerCase()) ||
          item.email.toLowerCase().includes(textFilter.toLowerCase())
        )
      })
      let arr = []

      const getByTypes = () => {
        for (let i = 0; i < selectFilter.length; i++) {
          const arrSelector = selectFilter[i].split("_")
          const typeUser = arrSelector[1] // active || invited
          const statusUser = parseInt(arrSelector[2], 10) // 1 || 0
          const result = filters.filter(
            (e) => e[`user_${typeUser}`] === statusUser
          )
          arr = [...arr, ...result]
        }
        return [...new Set(arr)]
      }

      if (selectFilter.length > 0) {
        return getByTypes()
      }

      return filters
    }

    return listLeaders
  }

  return (
    <>
      <div
        className="container-usermanagement__actions"
        style={{ top: 8, display: "flex" }}>
        <Tooltip placement="topRight" title="Activar líderes">
          <Button
            className="whiteButton"
            size="default"
            icon={<UploadOutlined />}
            onClick={() => props.history.push("/leaders/import")}
            disabled={countLeaders === 0}
          />
        </Tooltip>
        <Tooltip placement="topRight" title="Exportar líderes">
          <Button
            className="whiteButton mleft8"
            size="default"
            loading={props.isDownloading}
            icon={<DownloadOutlined />}
            onClick={() => {
              props.getTemplate()
              buttonAction_btns("Exportar líderes")
            }}
            disabled={countLeaders === 0}
          />
        </Tooltip>
      </div>

      <div
        className="container-usermanagement__tab-title color-black"
        style={{ color: countEmployees === 0 ? "#A2A2A2" : "" }}>
        Líderes
      </div>
      <p
        className="container-usermanagement__tab-description color-black"
        style={{
          color: countEmployees === 0 ? "#A2A2A2" : "",
          marginBottom: 10,
        }}>
        En esta sección, podrás visualizar y gestionar a los <b>líderes</b> de
        tu organización. Los usuarios asignados como líderes podrán tener su
        propio acceso a la plataforma, previamente configurando su correo y
        contraseña.
      </p>

      {loading && countLeaders === 0 && (
        <div className="loadingSpin">
          <Spin size="large" />
        </div>
      )}

      {showData && (
        <div style={{ marginTop: 20, display: "flex" }}>
          <Input
            placeholder="Buscar..."
            style={{ width: 270, marginBottom: "1.5rem" }}
            onChange={(e) => setTextFilter(e.target.value)}
            suffix={
              textFilter ? (
                <CloseCircleOutlined
                  style={{
                    cursor: "pointer",
                    color: "white",
                    background: "rgba(0, 0, 0, 0.25)",
                    borderRadius: "50%",
                  }}
                  onClick={() => {
                    setTextFilter("")
                  }}
                />
              ) : (
                <SearchOutlined />
              )
            }
          />

          <Select
            mode="multiple"
            style={{ marginLeft: 15, width: 250 }}
            placeholder="Seleccionar usuarios"
            onChange={(e) => setSelectFilter(e)}>
            <Option value="user_active_1">Usuarios activados</Option>
            <Option value="user_active_0">Usuarios desactivados</Option>
            <Option value="user_invited_1">
              Usuarios notificados (correo)
            </Option>
            <Option value="user_invited_0">
              Usuarios sin notificar (correo)
            </Option>
          </Select>

          <div style={{ marginLeft: "auto", textAlign: "right" }}>
            {usersSelectedActive.length > 0 && (
              <Button
                onClick={() => {
                  setUsersSelected(usersSelectedActive)
                  setModalDesactivate(true)
                }}
                style={{ marginRight: 15 }}
                type="danger">
                Desactivar usuarios
              </Button>
            )}

            <Popover
              placement="top"
              {...(usersSelectedDisable.length > 0 ? { visible: false } : {})}
              content={
                <div style={{ maxWidth: 275 }}>
                  Se debe contar con usuarios <b>desactivados seleccionados</b>{" "}
                  para poder habilitar la acción.
                </div>
              }>
              <Button
                onClick={() => {
                  setUsersSelected(usersSelectedDisable)
                  setModalInvite(true)
                  buttonAction_btns("Activar usuarios lideres")
                }}
                disabled={usersSelectedDisable.length === 0}
                style={{ marginBottom: 15 }}
                type="primary">
                Activar usuarios
              </Button>
            </Popover>
            <Button
              onClick={() => {
                setUsersSelected(usersSelectedToInvite)
                setModalEmail(true)
                buttonAction_btns("Enviar invitacion a lider")
              }}
              disabled={
                usersSelectedToInvite.length === 0 ||
                usersSelectedInactive.length > 0
              }
              style={{ marginLeft: 15 }}
              type="primary">
              Enviar invitación
            </Button>
          </div>
        </div>
      )}

      <div>
        {renderEmpty()}

        {showData && (
          <Table 
            className="container-usermanagement__table"
            columns={columns}
            rowKey={(record) => record.id_employee}
            dataSource={Array.isArray(getDataTable()) ? getDataTable() : []}
            rowSelection={rowSelection}
            loading={loading}
            locale={{ emptyText: "No hay líderes para mostrar" }}
            pagination={{
              pageSizeOptions: ["15", "25", "50", "100"],
              showSizeChanger: true,
              size: "default",
              defaultPageSize: 15,
            }}
          />
        )}
      </div>

      <ModalInvitate
        onFinish={() => {
          setModalInvite(false)
          getLeaders()
        }}
        open={modalInvite}
        onCancel={() => setModalInvite(false)}
        usersSelected={usersSelected}
      />

      <ModalEmail
        onFinish={() => {
          setModalEmail(false)
          getLeaders()
        }}
        open={modalEmail}
        onCancel={() => setModalEmail(false)}
        usersSelected={usersSelected}
      />

      <ModalDesactivate
        onFinish={() => {
          setModalDesactivate(false)
          getLeaders()
        }}
        open={modalDesactivate}
        onCancel={() => setModalDesactivate(false)}
        usersSelected={usersSelected}
      />
    </>
  )
}

const mapStateToProps = createStructuredSelector({
  isDownloading: makeSelectIsDownloading(),
})

function mapDispatchToProps(dispatch) {
  return {
    getTemplate: (params) => dispatch(getTemplate(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({
  key: "controlPanelUserManagementLeader",
  reducer,
})
const withSaga = injectSaga({
  key: "controlPanelUserManagementLeader",
  saga,
})

export default compose(withReducer, withSaga, withConnect)(Leader)
